import { CustomerCategoriesView } from '~/components/customers/categories';
import { PageContainer } from '~/components/page-container';

export function CustomerCategories() {
	return (
		<PageContainer>
			<CustomerCategoriesView />
		</PageContainer>
	);
}
